import { Ably } from "@pankod/refine-ably";
import { config } from "config";

if (!config.ABLY_API_KEY) {
  // eslint-disable-next-line no-console
  console.warn("REACT_APP_ABLY_API_KEY is missing — real-time features (chat) are disabled.");
}

export const ablyClient = config.ABLY_API_KEY ? new Ably.Realtime(config.ABLY_API_KEY) : undefined;
